import React, {useState, useEffect} from 'react';

const FooterLanding = ({email, address, links, socialMediaLinks, gemeenteLinks, samenWerking, gemeenteName}) => {
    const [scrollBtn, setScrollBtn] = useState(false);


useEffect(() => {
    const handleScroll = () => {
        if (window.scrollY > 100) {
            setScrollBtn(true);
        } else {
            setScrollBtn(false);
        }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);

const scrollTop = () => {
    window.scrollTo(0, 0);
};

return (
    <>
        <section className="footer-area footer-area-landing">
            <div className="footer-top">
                <div className="container">
                    <div className="row footer-widget-wrap">
                        <div className="col footer-item footer-item1">
                            <h3 className="widget__title">Ouders Lokaal {gemeenteName}</h3>
                            <ul className="foot__links">
                                <li>
                                    Waverbancken 4
                                    3645 VS Vinkeveen
                                </li>
                                <li>
                                    <a href={`mailto:${email}`}>
                                        <i className="fa fa-envelope"></i>
                                        info@ouderslokaal.nl
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col footer-item footer-item3">
                            <h3 className="widget__title">Organisatie</h3>
                            <ul className="foot__links">
                                <li><a href="/Organisatiestructuur-voor-website.pdf" target="_blank">Onze organisatie</a></li>
                                <li><a href="/Jaarverslag-Ouders-Lokaal-2018.pdf" target="_blank">Jaarverslag 2018</a></li>
                                <li><a href="/Stichting-Ouders-Lokaal-Jaarrekening-2019.pdf" target="_blank">Jaarverslag 2019</a></li>
                                <li><a href="/Stichting-Ouders-Lokaal-Jaarrekening-2020.pdf" target="_blank">Jaarverslag 2020</a></li>
                                <li><a href="/Stichting-Ouders-Lokaal-Jaarrekening-2021.pdf" target="_blank">Jaarverslag 2021</a></li>
                                <li><a href="/Stichting-Ouders-Lokaal-Jaarrekening-2022.pdf" target="_blank">Jaarverslag 2022</a></li>
                                <li><a href="/beleidsplan-Ouders-Lokaal.pdf" target="_blank">Ons Beleid</a></li>
                                <li><a href="/privacy-beleid.pdf" target="_blank">Privacy Beleid</a></li>
                            </ul>
                        </div>
                        <div className="col footer-item footer-item3">
                            <h3 className="widget__title">Gemeenten</h3>
                            <ul className="foot__links">
                                <li><a href="https://derondevenen.ouderslokaal.nl">De Ronde Venen</a></li>
                                <li><a href="https://stichtsevecht.ouderslokaal.nl">Stichtse Vecht</a></li>
                                <li><a href="https://debilt.ouderslokaal.nl/">De Bilt</a></li>
                            </ul>
                        </div>
                        <div className="col footer-item footer-item4">
                            <h3 className="widget__title">Lokaal samenwerking</h3>
                            <ul className="contact__info">
                                <li className='mb-2'>
                                    Ouders Lokaal is een samenwerking tussen ouders en lokale samenwerkingspartners.
                                </li>
                            </ul>
                            {/* <div className="footer__social">

                                <ul>
                                <li>social</li>
                                </ul>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copyright-desc">
                                <p>
                                    © Copyright {new Date().getFullYear()} All rights reserved, Ouders Lokaal
                                </p>
                            </div>
                            <div className='footer-contentful'>
                                <a href="https://www.contentful.com/" rel="nofollow" target="_blank">
                                    <img src="https://images.ctfassets.net/fo9twyrwpveg/7F5pMEOhJ6Y2WukCa2cYws/398e290725ef2d3b3f0f5a73ae8401d6/PoweredByContentful_DarkBackground.svg" alt="Powered by Contentful" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div
            role="button"
            onKeyUp={scrollTop}
            tabIndex="0"
            onClick={scrollTop}
            id="back-to-top"
            className={scrollBtn ? "back-btn-shown" : ""}
        >
            <i className="fa fa-angle-up" title="Go top"></i>
        </div>
    </>
)
}

export default FooterLanding